import GiftCardBalanceCheck from 'components/Content/GiftCards/GiftCardBalanceCheck/GiftCardBalanceCheck';
import { withGiftCardBalanceCheckProps } from 'viewModel/content/giftCards/giftCardBalanceCheck/withGiftCardBalanceCheckProps';

export default withGiftCardBalanceCheckProps(GiftCardBalanceCheck);
